<template>
  <div>
    <div v-for="(item, index) in dataList" :key="item.id + index">
      <div class="wrap-style">
        <table border="1" class="table-style" width="100%">
          <tr>
            <td class="tac print-title" colspan="5">领料单号：{{ item.billNo }}</td>
          </tr>
          <tr>
            <td class="tac table-title">MO票号</td>
            <td class="tac mo-ticket-codes" colspan="3">{{ item.moTicketCodes }}</td>
            <td class="tac">
              <QrCode class="qr-code" id="moBillNoQrCode2" :text="item.billNo" width="130" height="130" />
            </td>
          </tr>
          <tr>
            <td class="tac table-title" width="13%">物料编码</td>
            <td class="tac table-title">物料名称</td>
            <td class="tac table-title" width="16%">合计</td>
            <td class="tac table-title" width="17%">领料数量</td>
            <td class="tac table-title" width="17%">补料数量</td>
          </tr>
          <tr v-if="!item.detailList || item.detailList.length===0">
            <td class="tac" colspan="5">空</td>
          </tr>
          <tr v-for="(material, materialIndex) in item.detailList" :key="material.itemCode + materialIndex">
            <td class="tac">{{ material.itemCode }}</td>
            <td class="tac" >{{ material.itemName }}</td>
            <td class="tac">{{ material.requisitionQuantity }}</td>
            <td class="tac">{{ material.llsl }}</td>
            <td class="tac">{{ material.blsl }}</td>
          </tr>
          <tr>
            <td class="tac table-title">备注</td>
            <td class="tac" colspan="4">{{ item.remark }}</td>
          </tr>
          <tr>
            <td class="tac table-title">退料</td>
            <td class="tac">{{ item.tbl }}</td>
            <td class="tac table-title">真皮批次</td>
            <td class="tac" colspan="2">{{ item.zppc }}</td>
          </tr>
          <tr>
            <td class="tac table-title" colspan="5">
              <div class="info">
                <div class="item">仓库主管:</div>
                <div class="item">车间主管:</div>
                <div class="item">收货人:</div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import QrCode from '@/components/QrCode/index.vue'

export default {
  name: 'PrintMergeMaterial',
  components: { QrCode },
  data () {
    return {
      dataList: []
    }
  },
  methods: {
    show(dataList) {
      this.dataList = dataList
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
.wrap-style{
  font-family: "黑体", "微软雅黑", "宋体", serif;
  color: #000;
  page-break-after: always;
  padding: 10px;
  font-size: 15px;
  table{
    border: 2px solid #000;
  }
}
.info{
  display: flex;
  justify-content: space-between;
  .item{
    text-align: left;
    padding-left: 4.2%;
    width: 33%;
  }
}
.print-title{
  font-weight: 600;
  font-size: 16px;
}
.table-title{
  font-weight: 600;
  font-size: 15px;
}
.table-style{
  width: 100%;
}
.tac{
  text-align: center;
}
tr{
  height: 30px;
}
td{
  padding: 0 5px;
}
.tip{
  margin-top: 10px;
}
/deep/.qr-code {
  margin: 2px 0;
  img {
    margin: auto;
  }
}
.mo-ticket-codes {
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
}
</style>
